import "whatwg-fetch";
import "tippy.js/dist/tippy.css";
import "../styles/index.scss";
import loader from "./loader";

if (process.env.NODE_ENV === "development") {
  require("../index.html");
}

window.addEventListener("load", () => {
  console.log("Spamhaus widgets loaded...");
  console.log("Data URL " + DATA_URL);
  loader();
});
